/**
 * kult-abo-calc.js — Abo-Mengen-Rechnung (Kult Club nach kg, 09.10.2026), ohne DOM, ohne Storage.
 * Grundlage: docs/requirements/2026-10-09-kult-club-kg-konzept.md §5/§6, Plan …-kg-plan.md §4.
 * Eine Abo-Menge (500–3.000 g in 250-g-Schritten) besteht aus 1-kg-, 500-g- und 250-g-Beuteln, größter zuerst.
 * Preis = Summe der Beutelpreise, Club-Rabatt je Beutel auf den Cent abgerundet, dann × Anzahl – so rechnet Shopify den
 * automatischen Rabatt (UX-Review S3, gemessen: 10,99 € − 7 % = 10,23 €; 2 × 1 kg = 2 × 39,06 €), damit PDP, Rechner,
 * Warenkorb und Kasse gleich sind.
 * Versand je Abo-Lieferung aus snippets/kult-versand-werte.liquid: mit Gramm-Grenze (aboFreiGramm > 0) frei ab
 * dieser Menge, sonst (alte Werte) frei ab der €-Grenze aboFreeCents (0 = immer frei).
 *
 * window.KultAboCalc
 *   split(grams, sizes)        → [{ grams, count }] größter Beutel zuerst; null, wenn die Menge nicht aufgeht
 *   bagsLabel(parts)           → „1 × 1 kg + 1 × 250 g“
 *   clubCents(cents, pct)      → Abo-Preis je Beutel (Rabatt abgerundet)
 *   lineCents(cents, n, pct)   → Abo-Preis einer Zeile mit n Beuteln (Rabatt je Beutel abgerundet, wie Shopify)
 *   quote(o)                   → { grams, parts, lines, listCents, aboCents, shipCents, free, unitCents, perKgCents, available }
 *       o: grams, pct, sizes ([1000, 500, 250]), variantFor(g) → { id, price, available } | null,
 *          shipping { aboVersandCents, aboFreiGramm, aboFreeCents }
 *   nextFree(o, max, step)     → Angebot der kleinsten größeren Menge, die versandfrei ist, oder null
 *   cheapestPerKg(o, min, max, step) → kleinste Menge mit dem niedrigsten Preis je kg inkl. Versand
 *   fmtGrams(g)                → „750 g“, „1 kg“, „1.250 g“
 *   setId()                    → Gruppen-ID für die Zeileneigenschaft _kultabo_set
 */
(function () {
  'use strict';
  if (window.KultAboCalc) return;

  function split(grams, sizes) {
    var list = (sizes || [1000, 500, 250]).slice().sort(function (a, b) { return b - a; });
    var rest = grams;
    var parts = [];
    list.forEach(function (size) {
      var count = Math.floor(rest / size);
      if (count > 0) { parts.push({ grams: size, count: count }); rest -= count * size; }
    });
    return rest === 0 && parts.length ? parts : null;
  }

  function fmtGrams(g) {
    if (g > 0 && g % 1000 === 0) return (g / 1000) + ' kg';
    return Math.round(g).toLocaleString('de-DE') + ' g';
  }

  function bagsLabel(parts) {
    return (parts || []).map(function (p) { return p.count + ' × ' + fmtGrams(p.grams); }).join(' + ');
  }

  function lineCents(cents, count, pct) {
    var c = cents || 0;
    return (c - Math.floor(c * (pct || 0) / 100)) * (count || 1);
  }

  function clubCents(cents, pct) {
    return lineCents(cents, 1, pct);
  }

  function isFree(grams, aboCents, shipping) {
    var s = shipping || {};
    if (s.aboFreiGramm > 0) return grams >= s.aboFreiGramm;
    if (!s.aboFreeCents) return true;
    return aboCents >= s.aboFreeCents;
  }

  function quote(o) {
    var parts = split(o.grams, o.sizes);
    var q = { grams: o.grams, parts: parts || [], lines: [], listCents: 0, aboCents: 0, shipCents: 0, free: false, unitCents: 0, perKgCents: 0, available: !!parts };
    if (!parts) return q;
    parts.forEach(function (p) {
      var v = o.variantFor ? o.variantFor(p.grams) : null;
      if (!v) { q.available = false; return; }
      if (!v.available) q.available = false;
      q.lines.push({ id: v.id, count: p.count, grams: p.grams });
      q.listCents += v.price * p.count;
      q.aboCents += lineCents(v.price, p.count, o.pct);
    });
    var s = o.shipping || {};
    q.free = isFree(o.grams, q.aboCents, s);
    q.shipCents = q.free ? 0 : (s.aboVersandCents || 0);
    q.unitCents = Math.round(q.aboCents * 1000 / o.grams);
    q.perKgCents = Math.round((q.aboCents + q.shipCents) * 1000 / o.grams);
    return q;
  }

  function withGrams(o, g) {
    var c = {};
    Object.keys(o).forEach(function (k) { c[k] = o[k]; });
    c.grams = g;
    return c;
  }

  function nextFree(o, max, step) {
    for (var g = o.grams + step; g <= max; g += step) {
      var q = quote(withGrams(o, g));
      if (q.available && q.free) return q;
    }
    return null;
  }

  function cheapestPerKg(o, min, max, step) {
    var best = null;
    for (var g = min; g <= max; g += step) {
      var q = quote(withGrams(o, g));
      if (q.available && (!best || q.perKgCents < best.perKgCents)) best = q;
    }
    return best ? best.grams : 0;
  }

  function setId() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  window.KultAboCalc = { split: split, bagsLabel: bagsLabel, clubCents: clubCents, lineCents: lineCents, quote: quote, nextFree: nextFree, cheapestPerKg: cheapestPerKg, fmtGrams: fmtGrams, setId: setId };
})();
